module.exports = __webpack_public_path__ + "static/media/salesReport.87572953.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mm/salesReport.png
// module id = 615
// module chunks = 0